import { Skeleton } from '@mui/material';
import { Translation } from '@ps/web-shared-components';
import type { ChangeEvent } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { RadioGroup, useHomeGamesWidget } from '@swf/poker';

import usePutClubOptions from '../hooks/usePutClubOptions';
import { row } from '../shared.scss';

import {
  TXTCLI_Private,
  TXTWCL_Anyone_can_find_this_club,
  TXTWCL_Can_only_be_found_through_an_i_ELL,
  TXTWCL_Club_Type,
  TXTWCL_Public,
  TXTWCL_Setting_your_club_to_Public_wi_ELL
} from './ClubPrivacy.messages.json';
import styles from './ClubPrivacy.scss';

enum ClubType {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

const radioOptions = [
  {
    value: ClubType.Public,
    label: (
      <div className={styles.option}>
        <Translation {...TXTWCL_Public} />
        <span>
          {' '}
          - <Translation {...TXTWCL_Anyone_can_find_this_club} />
        </span>
      </div>
    )
  },
  {
    value: ClubType.Private,
    label: (
      <div className={styles.option}>
        <Translation {...TXTCLI_Private} />
        <span>
          {' '}
          - <Translation {...TXTWCL_Can_only_be_found_through_an_i_ELL} />
        </span>
      </div>
    )
  }
];

const ClubPrivacy: React.FC = () => {
  const { clubId } = useParams<{ clubId: string }>();
  const { widgetSelect } = useHomeGamesWidget();
  const clubOptionsById = useSelector(widgetSelect.clubOptionsById);
  const discoverable = clubOptionsById[clubId]?.discoverable;
  const open = clubOptionsById[clubId]?.open;
  const { loading, onClubOptionsChange } = usePutClubOptions();
  const selectedOption = discoverable && open ? ClubType.Public : ClubType.Private;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (event: ChangeEvent<any>) => {
    const { value } = event.target;
    const payloadValue = value === ClubType.Private ? false : true;

    onClubOptionsChange({
      clubId: Number(clubId),
      discoverable: payloadValue,
      open: payloadValue
    });
  };

  return (
    <div className={row}>
      <Translation tagName="h2" {...TXTWCL_Club_Type} />
      {typeof discoverable !== 'undefined' ? (
        <RadioGroup
          disabled={loading}
          name="clubSeasonType"
          options={radioOptions}
          selectedOption={selectedOption}
          onChange={handleChange}
        />
      ) : (
        <div className={styles.skeleton}>
          {radioOptions.map(({ value }) => (
            <div key={value}>
              <Skeleton variant="circular" />
              <Skeleton variant="text" />
            </div>
          ))}
        </div>
      )}
      <div className={styles.helperText}>
        <Translation {...TXTWCL_Public} />
        {': '}
        <Translation {...TXTWCL_Setting_your_club_to_Public_wi_ELL} />
      </div>
    </div>
  );
};

export default ClubPrivacy;
